export default "__VITE_PUBLIC_ASSET__15a3c137__"